if (!customElements.get('dynamic-team-slider')) {
  customElements.define(
    'dynamic-team-slider',
    class DynamicTeamSlider extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-slider-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.buttons = [...this.querySelectorAll('[data-slide-button]')];
        this.frame = null;
      }

      connectedCallback() {
        if (!this.track || this.slides.length < 2) return;

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.goTo(Number(button.dataset.slideButton)));
        });

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateActiveSlide());
        }, { passive: true });
      }

      goTo(index) {
        this.track.scrollTo({ left: this.slides[index].offsetLeft, behavior: 'smooth' });
      }

      updateActiveSlide() {
        const index = Math.max(0, Math.min(
          this.slides.length - 1,
          Math.round(this.track.scrollLeft / this.track.clientWidth)
        ));

        this.buttons.forEach((button, buttonIndex) => {
          const isActive = buttonIndex === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
